import { TPlayerActionData } from './hooks';
import { FunctionEventTypeEnum } from './widget/enums';
import { TWidget } from './widget/widget';

export type TEventPayload = {
    value?: TPlayerActionData;
    widget?: TWidget<unknown>;
    internalId?: string;
};

export enum SystemEventTypeEnum {
    EXECUTE = 'execute',
    TOAST_MESSAGE = 'toastMessage',
    IS_DEFAULT_BUTTON_ENABLED = 'isDefaultButtonEnabled',
    SIZE = 'size',
    SCROLLED = 'scrolled',
    WS = 'ws',
    CF = 'CF',
}

export type TEvent = {
    type: SystemEventTypeEnum | FunctionEventTypeEnum | string;
    payload: TEventPayload;
};
export type TEventCallback = (data?: TEventPayload['value']) => void;
export type TEventWsCallback = (data?: TEventPayload['widget']) => void;
